<template>
  <div id="surveying-action-buttons" class="container-fluid">
    <div class="row">
      <div class="col-4">
        <div class="row justify-content-center">
          <div class="col-5 text-center">
            <button
              type="button"
              class="btn btn-secondary btn-sm my-1 border border-light"
              :disabled="disableButtons"
              @mousedown="keyDown(Keys.W)"
              @mouseup="keyUp(Keys.W)"
              @touchstart="keyDown(Keys.W)"
              @touchend="keyUp(Keys.W)"
            >
              W
            </button>
          </div>
        </div>
        <div class="row justify-content-center">
          <div
            class="btn-group btn-group-sm col-8 mb-1"
            role="group"
            aria-label="ASD key buttons"
          >
            <button
              type="button"
              class="btn btn-secondary border border-light"
              :disabled="disableButtons"
              @mousedown="keyDown(Keys.A)"
              @mouseup="keyUp(Keys.A)"
              @touchstart="keyDown(Keys.A)"
              @touchend="keyUp(Keys.A)"
            >
              A
            </button>
            <button
              type="button"
              class="btn btn-secondary border border-light"
              :disabled="disableButtons"
              @mousedown="keyDown(Keys.S)"
              @mouseup="keyUp(Keys.S)"
              @touchstart="keyDown(Keys.S)"
              @touchend="keyUp(Keys.S)"
            >
              S
            </button>
            <button
              type="button"
              class="btn btn-secondary border border-light"
              :disabled="disableButtons"
              @mousedown="keyDown(Keys.D)"
              @mouseup="keyUp(Keys.D)"
              @touchstart="keyDown(Keys.D)"
              @touchend="keyUp(Keys.D)"
            >
              D
            </button>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="row justify-content-center">
          <button
            type="button"
            class="col-auto mb-1 btn btn-secondary btn-sm border border-light"
            :disabled="disableButtons"
            @click="$emit('zKey')"
          >
            Z
          </button>
          <div
            class="btn-group btn-group-sm col-8 mb-1"
            role="group"
            aria-label="direction key buttons"
          >
            <button
              type="button"
              class="btn btn-secondary border border-light"
              :disabled="disableButtons"
              @mousedown="keyDown(Keys.J)"
              @mouseup="keyUp(Keys.J)"
              @touchstart="keyDown(Keys.J)"
              @touchend="keyUp(Keys.J)"
            >
              J
            </button>
            <button
              type="button"
              class="btn btn-secondary border border-light"
              :disabled="disableButtons"
              @mousedown="keyDown(Keys.I)"
              @mouseup="keyUp(Keys.I)"
              @touchstart="keyDown(Keys.I)"
              @touchend="keyUp(Keys.I)"
            >
              I
            </button>
            <button
              type="button"
              class="btn btn-secondary border border-light"
              :disabled="disableButtons"
              @mousedown="keyDown(Keys.K)"
              @mouseup="keyUp(Keys.K)"
              @touchstart="keyDown(Keys.K)"
              @touchend="keyUp(Keys.K)"
            >
              K
            </button>
            <button
              type="button"
              class="btn btn-secondary border border-light"
              :disabled="disableButtons"
              @mousedown="keyDown(Keys.L)"
              @mouseup="keyUp(Keys.L)"
              @touchstart="keyDown(Keys.L)"
              @touchend="keyUp(Keys.L)"
            >
              L
            </button>
          </div>
        </div>
        <div class="row justify-content-center">
          <div class="col-auto text-center">
            <button
              type="button"
              class="btn btn-secondary btn-sm w-100 mb-1 border border-light"
              :disabled="disableButtons"
              @mousedown="keyDown(Keys.SHIFT)"
              @mouseup="keyUp(Keys.SHIFT)"
              @touchstart="keyDown(Keys.SHIFT)"
              @touchend="keyUp(Keys.SHIFT)"
            >
              Shift
            </button>
          </div>
          <div class="col-auto text-center">
            <button
              type="button"
              class="btn btn-secondary btn-sm w-100 mb-1 border border-light"
              :disabled="disableButtons"
              @click="$emit('fKey')"
            >
              F
            </button>
          </div>
        </div>
      </div>
      <div class="col-2">
        <div class="row justify-content-center">
          <button
            type="button"
            class="col-auto btn btn-secondary btn-sm my-1 border border-light"
            :disabled="disableButtons"
            @click="$emit('zeroKey')"
          >
            0
          </button>
          <button
            type="button"
            class="col-auto btn btn-secondary btn-sm my-1 border border-light"
            :disabled="disableButtons"
            @click="$emit('twoKey')"
          >
            2
          </button>
        </div>
        <div class="row justify-content-center">
          <button
            type="button"
            class="col-auto btn btn-secondary btn-sm my-1 border border-light"
            :disabled="disableButtons"
            @click="$emit('pKey')"
          >
            P
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { KEYS as Keys } from "@/helpers/constants.js";

export default {
  name: "MobileButtonPanel",
  props: {
    disableButtons: Boolean,
    keyDown: Function,
    keyUp: Function
  },
  data() {
    return {
      Keys
    };
  }
};
</script>

<style scoped>
.accordion {
  min-width: 40%;
}

/* Disable double-tap to zoom on specific buttons */
button {
  touch-action: manipulation; /* 'none' can also work, but this preserves some gesture functionality */
}

/* Un-comment below for a translucent card background */
/* #surveying-action-buttons {
  background-color: rgba(255, 255, 255, 0.5);
} */
</style>
